import { Card, Separator } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../../urlBuilder';

export const ActivityLinkFooter = ({ accountIds = [] }: { accountIds?: string[] }) => {
  return (
    <>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Footer css={{ padding: 'space.300' }}>
        <SambaAutoLink to={urlBuilder.appActivity.absolute({ account_id: accountIds })}>See all</SambaAutoLink>
      </Card.Footer>
    </>
  );
};
